<template>
  <div class="one-seek-help">
    <van-overlay :show="show" @click="show = false">
      <div class="phone_box">
        <div class="box_head">
          <div class="head_title">请拨打求助对象所属园区电话</div>
          <div class="head_close">
            <img src="../../assets/img/icon_close.png" alt="" />
          </div>
        </div>
        <div v-for="(item, index) in phoneList" :key="index" @click.stop="callPhone(item)">
          <div class="box_item" v-if="item.telNo">
            <div class="address">
              {{ item.scenicName }} <span>{{ `(${item.telNo})` }}</span>
            </div>
            <div class="item_icon" v-if="item.scenicName == scenicName">
              <img src="../../assets/img/compale_icon.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- <div class="title">
      <van-nav-bar title="一键求助">
        <van-icon name="arrow-left" slot="left" @click="Back()" />
      </van-nav-bar>
    </div> -->
    <!-- 地图 -->
    <div class="map-box">
      <div class="map">
        <div id="container"></div>
        <div class="my-complain" @click="MyHelp()">
          <van-image :src="myHelpIcon" width="12px" height="12px"></van-image>
          <span>我的求助</span>
        </div>
        <div class="help-content">
          <div class="help">
            <div @click="OnlineHelp">
              <van-image :src="onlineImg" width="38px" height="38px"></van-image>
              <p>在线求助</p>
            </div>
            <div @click="callHelp">
              <van-image :src="photoImg" width="38px" height="38px"></van-image>
              <p>电话求助</p>
            </div>
          </div>
          <div class="site">
            <van-image :src="siteIcon" width="10px" height="11px"></van-image>
            <span>{{ this.address }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import qs from "qs";
import axios from "axios";
import { Dialog } from "vant";
export default {
  data() {
    return {
      siteIcon: require("../../assets/iconImage/ic_20_location@2x.png"),
      onlineImg: require("../../assets/iconImage/ic_fankui@2x.png"), // 在线求助
      photoImg: require("../../assets/iconImage/ic_wenjuan@2x.png"), // 电话求助
      address: "",
      url: "", // 微信授权地址
      state: "abc123", // 微信授权状态码
      myHelpIcon: require("../../assets/iconImage/ic_collection@3x.png"),
      show: false,
      phoneList: [],
      scenicName: "",
    };
  },
  mounted() {
    document.title = "一键求助";
    this.scenicName = this.$route.query.scenicName;
    let lat = sessionStorage.getItem("dislLat") || "";
    let lng = sessionStorage.getItem("dislLng") || "";
    this.getAddress(lat, lng).then((res) => {
      if (res) {
        this.address = res.address;
        this.cityLocation = res.address;
        this.init(lat, lng);
      } else {
        this.address = "定位服务未开启";
        this.cityLocation = "定位服务未开启";
        lat = 30.5632594;
        lng = 104.0677888;
        this.init(lat, lng, true);
      }
    });

    if (
      localStorage.getItem("mobile") !== "" &&
      this.$cookie.get("w_uid") == 0
    ) {
      if (this.$cookie.get("w_uid") == 0 && window.location.href.includes("state=wxAuth2")) {
        this.$router.replace({
          name: "bindingPhone",
        });
      } else {
        this.wxAuth("wxAuth2");
      }
      // this.wxAuth();
    }
  },
  methods: {
    /**
     * 打点话
     */
    callPhone(item) {
      if (item.telNo) {
        window.location.href = `tel:${item.telNo}`;
      }
    },

    getAddress(lat, lng) {
      return new Promise((resolve, reject) => {
        $.ajax({
          type: "get",
          url: "https://apis.map.qq.com/ws/geocoder/v1/",
          dataType: "jsonp",
          data: {
            key: "LJKBZ-2WTRW-JT7RQ-OSONW-ZO6X7-ZMFMG", //开发密钥
            location: `${lat},${lng}`, //位置坐标
            get_poi: "0", //是否返回周边POI列表：1.返回；0不返回(默认)
            coord_type: "1", //输入的locations的坐标类型,1 GPS坐标
            output: "jsonp",
          },
          success: (data) => {
            resolve(data.result);
          },
        });
      });
    },
    // 返回上一页
    Back() {
      this.$router.push({ path: "/" });
    },
    //电话求助
    callHelp() {
      if (this.phoneList.length > 0) {
        this.show = true;
        return;
      }

      axios
        .create({
          baseURL: this.newUrlHost,
          headers: {},
          withCredentials: true,
        })
        .get("/appserver/v1/complaint/getComplaintTelAll")
        .then((data) => {
          console.log(data, "data");
          if (data.data.ret === 0) {
            if (data.data.data === null) {
              this.$toast({
                message: data.data.msg,
                duration: "5000",
              });
            } else {
              if (this.$route.query.greenwayIn == 1) {
                // 在景区
                let tel = "";
                let phoneList = data.data.data;
                for (let i in phoneList) {
                  if (phoneList[i].scenicName == this.$route.query.scenicName) {
                    tel = phoneList[i].telNo;
                  }
                }
                if (tel) {
                  Dialog.confirm({
                    title: "电话投诉",
                    message: tel,
                    showCancelButton: true,
                    confirmButtonText: "拨号",
                    confirmButtonColor: "#2EBA73",
                  })
                    .then(() => {
                      window.location.href = "tel:" + tel;
                    })
                    .catch(() => {
                      console.log("cancel");
                    });
                } else {
                  this.$toast({
                    message: "该园区暂未提供电话求助服务",
                    duration: "5000",
                  });
                }

              } else {
                this.phoneList = data.data.data;
                this.show = true;
              }
            }
          } else {
            this.$toast({
              message: "该园区暂未提供电话求助服务",
              duration: "5000",
            });
          }
        });
    },
    // 在线求助
    OnlineHelp() {
      if (
        this.$cookie.get("w_open_id") == "" ||
        this.$cookie.get("w_open_id") == null
      ) {
        this.$toast("请授权");
        this.wxAuth();
      } else {
        this.getUserInfo(
          this.$cookie.get("w_uid"),
          this.$cookie.get("w_open_id"),
          this.$cookie.get("w_skey")
        );
        //判断用户是否登录
        // if (
        //   localStorage.getItem('mobile') === '' ||
        //   localStorage.getItem('mobile') === 'undefined' ||
        //   localStorage.getItem('mobile') === null
        // ) {
        //   this.$router.push({ path: '/bindingPhone' });
        // } else {
        // this.$router.push({
        //   path: '/onlineHelp',
        //   query: {
        //     latitude: this.$route.query.latitude,
        //     longitude: this.$route.query.longitude,
        //     cityLocation: this.cityLocation,
        //   },
        // });
        // }
      }
    },

    /**
     * 获取用户信息
     * @params skey openid uid
     */
    getUserInfo(uid, openId, skey) {
      console.log("发起请求");
      let data = new FormData();
      data.append("uid", uid);
      data.append("open_id", openId);
      data.append("skey", skey);
      this.$request
        .post(`/appserver/v1/user/get_auth_data`, data)
        .then((res) => {
          if (res.data.ret == 0) {
            localStorage.setItem("uid", res.data.data.uid);
            localStorage.setItem("userName", res.data.data.nickname);
            localStorage.setItem("userImg", res.data.data.head_img_url);
            localStorage.setItem("mobile", res.data.data.mobile);
            sessionStorage.setItem("userName", res.data.data.nickname);
            sessionStorage.setItem("userImg", res.data.data.head_img_url);
            // 如果手机号为空，跳转绑定手机号页面
            if (!res.data.data.mobile) {
              this.$router.replace({
                name: "bindingPhone",
              });
            } else {
              this.$router.push({
                path: "/onlineHelp",
                query: {
                  latitude: this.$route.query.latitude,
                  longitude: this.$route.query.longitude,
                  cityLocation: this.cityLocation,
                },
              });
            }
          } else if (res.data.ret == 1) {
            // 登录过期
            if (res.data.errorcode == 20002) {
              this.wxAuth();
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    //我的求助
    MyHelp() {
      if (
        localStorage.getItem("mobile") === "" ||
        localStorage.getItem("mobile") === undefined ||
        localStorage.getItem("mobile") === null
      ) {
        this.$router.push({ path: "/bindingPhone" });
      } else {
        this.$router.push({
          path: "/myHelp",
        });
      }
    },
    // 地图
    init(lat, lng, isHide) {
      /* eslint-disable */
      // 设置地图中心点
      var myLatlng = new qq.maps.LatLng(lat, lng);
      // var myLatlng = new qq.maps.LatLng(30.56263,104.06255);
      // 定义工厂模式函数
      var myOptions = {
        zoom: 13, // 设置地图缩放级别
        center: myLatlng, // 设置中心点样式
        zoomControl: false,
        disableDefaultUI: true,
        mapTypeId: qq.maps.MapTypeId.ROADMAP, // 设置地图样式详情参见MapType
      };
      // 获取dom元素添加地图信息
      var map = new qq.maps.Map(
        document.getElementById("container"),
        myOptions
      );
      var marker = new qq.maps.Marker({});
      var cssC = {
        // width: '160px',
        height: "20px",
        top: "300px",
        left: "150px",
        color: "#2EBA73",
        fontSize: "12px",
        borderRadius: "20px",
        borderColor: "#2EBA73",
        textAlign: "center",
        lineHeight: "20px",
        marginLeft: "-35px",
        marginTop: "-30px",
        overflow: "hidden",
        padding: "0 5px",
      };
      var label = new qq.maps.Label({
        position: myLatlng,
        map: map,
        style: cssC,
        content: this.cityLocation,
      });
      var cssR = {
        width: "4px",
        height: "4px",
        borderRadius: "50%",
        backgroundColor: "#2EBA73",
        left: "210px",
      };
      var label1 = new qq.maps.Label({
        position: myLatlng,
        map: map,
        style: cssR,
        content: "",
      });
      if (isHide) {
        marker.setVisible(false);
        label.setVisible(false);
        label1.setVisible(false);
      } else {
        marker.setVisible(true);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.one-seek-help {
  width: 100%;
  height: 100%;
  .title {
    /deep/ .van-nav-bar {
      z-index: 500 !important;
    }
    /deep/ .van-nav-bar .van-icon {
      color: #4a4a4a;
      font-size: 22px;
    }
    /deep/ .van-nav-bar__title {
      color: #4a4a4a;
      font-size: 16px;
    }
    /deep/ [class*="van-hairline"]::after {
      border: 0px;
    }
  }
  .map-box {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    // z-index: 300;
    .map {
      width: 100%;
      height: 100%;
      position: relative;
      #container {
        width: 100%;
        height: 100%;
        .csssprite {
          background: #fff;
          color: #2eba73;
          border-radius: 5%;
        }
      }
      .my-complain {
        position: absolute;
        top: 14px;
        right: 0px;
        width: 90px;
        height: 30px;
        background: #2eba73;
        // z-index: 1200;
        border-bottom-left-radius: 20px;
        border-top-left-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 30px;
        span {
          font-size: 13px;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          margin-left: 4px;
        }
      }
      .help-content {
        width: 89.34%;
        position: absolute;
        left: 20px;
        bottom: 34px;
        .help {
          background-color: #fff;
          width: 100%;
          padding: 26px 0 20px 0;
          display: flex;
          justify-content: space-around;
          & > div {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            & > p {
              text-align: center;
              margin-top: 14px;
              font-size: 14px;
              font-family: PingFangSC-Semibold, PingFangSC;
              font-weight: 600;
              color: rgba(55, 56, 77, 1);
              line-height: 14px;
              width: 100%;
            }
          }
        }
        .site {
          margin-top: 10px;
          background-color: #fff;
          padding: 19px 15px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          border-bottom: 10px solid #f8f8f8;
          & > span {
            margin-left: 6px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFangSC;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 12px;
          }
        }
      }
    }
  }
  .phone_box {
    width: 100%;
    max-height: 360px;
    background: #ffffff;
    border-radius: 8px 8px 0px 0px;
    padding: 20px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 0;
    .box_head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 15px;
      .head_title {
        font-size: 16px;
        // font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 700;
        color: #222222;
      }
      .head_close {
        width: 18px;
        height: 18px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .box_item {
      display: flex;
      justify-content: space-between;
      padding: 20px 0;
      border-bottom: 1px solid #e8e8e8;
      .address {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #555959;
      }
      .item_icon {
        width: 18px;
        height: 18px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      &:last-child {
        border: 0;
      }
    }
  }
}
</style>
